import React from 'react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import PageTabs from '../shared/PageTabs.jsx'
import '../../styles/pages.css'

const tabs = [
  // Browse is read-only for any authenticated staff (F8, 2026-09-15): the worker
  // opened GET /review/products* to the pim tier and the route uses ProtectedRoute.
  // Review Queue and Identify stay admin-only (mutations + customer evidence).
  { path: '/catalog/products', label: 'Browse' },
  { path: '/catalog/review', label: 'Review Queue', adminOnly: true },
  { path: '/catalog/identify', label: 'Identify', adminOnly: true },
  { path: '/catalog/label', label: 'Gold Labelling', adminOnly: true },
  { path: '/catalog/proposals', label: 'Proposals' },
  { path: '/catalog/settings', label: 'Engine Settings' }
]

function CatalogPage() {
  const { user } = useAuth()
  const visibleTabs = tabs.filter(t => !t.adminOnly || user?.is_admin)

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Catalog</h1>
        <p>Review the product knowledge graph: identities, attribute proposals, and engine settings</p>
      </div>

      <PageTabs tabs={visibleTabs} match="section" />

      <div style={{ marginTop: 28 }}>
        <Outlet />
      </div>
    </div>
  )
}

export default CatalogPage
